"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Ability_PowerApex_OnAttackEventHandlerScript = void 0;
const Duration_1 = require("../../core/Duration");
const Apex_1 = require("../../core/effects/core/Apex");
const EventType_1 = require("../../core/events/EventType");
const Registries_1 = require("../../core/state/Registries");
let Ability_PowerApex_OnAttackEventHandlerScript = class Ability_PowerApex_OnAttackEventHandlerScript {
    run(sequence, container, handler, event) {
        if (event.args.__type !== EventType_1.EventType.Attack) {
            return;
        }
        handler.meta.hitsWithoutCrit = handler.meta.hitsWithoutCrit || 0;
        if (!event.args.hit) {
            return;
        }
        container.cancelEffect(sequence, handler.meta.effectId);
        if (event.args.crit) {
            handler.meta.hitsWithoutCrit = 0;
            return;
        }
        handler.meta.hitsWithoutCrit++;
        handler.meta.effectId = container.applyBuff({
            sequence,
            creatorId: handler.subject,
            targetId: handler.subject,
            effect: new Apex_1.ApexEffectArgs(handler.meta.hitsWithoutCrit),
            duration: Duration_1.Duration.Permanent,
        });
    }
};
Ability_PowerApex_OnAttackEventHandlerScript = __decorate([
    Registries_1.EventHandlerScripts.register("Ability_PowerApex_OnAttack")
], Ability_PowerApex_OnAttackEventHandlerScript);
exports.Ability_PowerApex_OnAttackEventHandlerScript = Ability_PowerApex_OnAttackEventHandlerScript;
